// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import IntegrationCallListPagingResultModel from '../../model/integration-call-list-paging-result-model';
import IntegrationCallListPagingResultDTO from '../dto/integration-call-list-paging-result-dto';
import IntegrationCallListModel from '../../model/integration-call-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class IntegrationCallListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<IntegrationCallListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => IntegrationCallListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  'items'?: IntegrationCallListModel[];
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  */
  'paginationData'?: PaginationDataModel;

  static toModel(dto: DeepPartial<IntegrationCallListPagingResultDTO>): IntegrationCallListPagingResultModel;
  static toModel(dto: DeepPartial<IntegrationCallListPagingResultDTO> | undefined | null): IntegrationCallListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<IntegrationCallListPagingResultDTO> | undefined | null): IntegrationCallListPagingResultModel | undefined {
    return dto ? new IntegrationCallListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<IntegrationCallListPagingResultModel> | IntegrationCallListPagingResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
      'paginationData': unwrapped.paginationData,
    } as IntegrationCallListPagingResultDTO;
  }
}
